import React, { Component } from "react";
import { Modal, Form, Input, Col, Row, Button } from "antd";

const FormItem = Form.Item;

export default class AddDescModal extends Component {
  render() {
    const {
      toggleModal,
      showModal,
      handleDescChange,
      requestArticlePublish,
      newsDesc
    } = this.props;

    return (
      <Modal
        visible={showModal}
        title="Add description to publish notification"
        footer={null}
        onCancel={toggleModal}
        className="form-type-modal"
      >
        <Form layout="vertical">
          <FormItem label="Enter news notification description">
            <Input
              value={newsDesc}
              onChange={e => handleDescChange(e.target.value)}
            ></Input>
          </FormItem>
          <FormItem>
            <Row type="flex" gutter={20}>
              <Col>
                <Button type="primary" onClick={requestArticlePublish}>
                  Publish
                </Button>
              </Col>
              <Col>
                <Button onClick={toggleModal}>Cancel</Button>
              </Col>
            </Row>
          </FormItem>
        </Form>
      </Modal>
    );
  }
}
